var map = {
	"./ASK.svg": 3657,
	"./Icon/Contact.svg": 9237,
	"./Icon/P1/01.svg": 2249,
	"./Icon/P1/02.svg": 2668,
	"./Icon/P1/03.svg": 7031,
	"./Icon/P1/04.svg": 3458,
	"./Icon/P2/Step1.svg": 5947,
	"./Icon/P2/Step2.svg": 40,
	"./Icon/P2/Step3.svg": 8741,
	"./Icon/P2/StepArrow.svg": 6738,
	"./Icon/P3/Fast/01.svg": 9212,
	"./Icon/P3/Fast/02.svg": 4426,
	"./Icon/P3/Fast/03.svg": 2187,
	"./Icon/P3/Feature/01.svg": 3121,
	"./Icon/P3/Feature/02.svg": 5732,
	"./Icon/P3/Feature/03.svg": 6134,
	"./Icon/P3/Feature/04.svg": 5792,
	"./Icon/P3/Feature/05.svg": 243,
	"./Icon/P3/Feature/06.svg": 2674,
	"./Icon/P3/Feature/07.svg": 5485,
	"./Icon/P3/Feature/08.svg": 8075,
	"./Icon/P3/Feature/09.svg": 2980,
	"./Icon/P3/Safe/01.svg": 2305,
	"./Icon/P3/Safe/02.svg": 9989,
	"./Icon/P3/Safe/03.svg": 893,
	"./Icon/P3/Save/01.svg": 7697,
	"./Icon/P3/Save/02.svg": 5034,
	"./Icon/P3/Save/03.svg": 2766,
	"./Icon/P3/Special/01.svg": 247,
	"./Icon/P3/Special/02.svg": 9624,
	"./Icon/P3/Special/03.svg": 1114,
	"./Img/Footer.svg": 1783,
	"./Img/bigpic/1.png": 9248,
	"./Img/bigpic/2.png": 7790,
	"./Img/bigpic/3.png": 4412,
	"./Img/bigpic/4.png": 7520,
	"./Img/bigpic/5.png": 5945,
	"./Img/bigpic/6.png": 2655,
	"./Img/bigpic/7.png": 687,
	"./Img/i14P.webp": 2622,
	"./Img/macao.jpg": 5827,
	"./MGP.svg": 9763,
	"./flags/L/CN.svg": 9217,
	"./flags/L/HK.svg": 3571,
	"./flags/L/US.svg": 5275
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;